import { Int } from '@adornis/baseql/baseqlTypes.js';
import { registerSubscription } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { watchEntireCollection } from '@adornis/baseql/server/watchQuery.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';
import { TranslationEntry } from '@adornis/translation/db/translation-entry.js';
import { switchMap } from 'rxjs';

export const subscribeTranslationPaginatedResolver =
  (skip?: number, limit?: number, filter?: AdornisFilter) => (gqlFields: BaseQLSelectionSet<TranslationEntry>) =>
    watchEntireCollection(TranslationEntry._collectionName).pipe(
      switchMap(async () => {
        const trCol = await getRawCollection<TranslationEntry>(TranslationEntry._collectionName);
        const translationEntries = await trCol
          .aggregate([
            filter ? { $match: filter.getMongoFilter() } : {},
            ...(skip && limit ? [{ $skip: skip }, { $limit: limit }] : []),
          ])
          .toArray();
        return translationEntries as Array<TranslationEntry>;
      }),
    );

export const subscribeMentoringTranslations = registerSubscription({
  operationName: 'subscribeMentoringTranslations',
  type: () => [TranslationEntry],
  params: [
    { name: 'skip', type: () => Int },
    { name: 'limit', type: () => Int },
    { name: 'filter', type: () => AdornisFilter },
  ],
  resolve: subscribeTranslationPaginatedResolver,
});
